module.exports = __webpack_public_path__ + "static/media/Roman Gladiator.8f621a00.jpg";